import axiosInstance from '../helpers/axios';
import { officeOwnerConstants } from './constants';

export const createOfficeOwner = (ownerData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: officeOwnerConstants.CREATE_OFFICE_OWNER_REQUEST });
            const response = await axiosInstance.post('/officeOwner/create', ownerData);
            dispatch({
                type: officeOwnerConstants.CREATE_OFFICE_OWNER_SUCCESS,
                payload: { owner: response.data.owner },
            });
        } catch (error) {
            dispatch({
                type: officeOwnerConstants.CREATE_OFFICE_OWNER_FAILURE,
                payload: { error: error.response?.data?.message || 'Ошибка создания владельца' },
            });
        }
    };
};

export const getOfficeOwners = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: officeOwnerConstants.GET_OFFICE_OWNERS_REQUEST });
            const response = await axiosInstance.get('/officeOwners/get');
            dispatch({
                type: officeOwnerConstants.GET_OFFICE_OWNERS_SUCCESS,
                payload: { owners: response.data.owners },
            });
        } catch (error) {
            dispatch({
                type: officeOwnerConstants.GET_OFFICE_OWNERS_FAILURE,
                payload: { error: error.response?.data?.message || 'Ошибка загрузки владельцев' },
            });
        }
    };
};

export const updateOfficeOwner = (ownerId, ownerData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: officeOwnerConstants.UPDATE_OFFICE_OWNER_REQUEST });
            const response = await axiosInstance.put(`/officeOwner/update/${ownerId}`, ownerData);
            dispatch({
                type: officeOwnerConstants.UPDATE_OFFICE_OWNER_SUCCESS,
                payload: { owner: response.data.owner },
            });
        } catch (error) {
            dispatch({
                type: officeOwnerConstants.UPDATE_OFFICE_OWNER_FAILURE,
                payload: { error: error.response?.data?.message || 'Ошибка обновления владельца' },
            });
        }
    };
};

export const deleteOfficeOwner = (ownerId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: officeOwnerConstants.DELETE_OFFICE_OWNER_REQUEST });
            const response = await axiosInstance.delete(`/officeOwner/delete/${ownerId}`);
            dispatch({
                type: officeOwnerConstants.DELETE_OFFICE_OWNER_SUCCESS,
                payload: { ownerId },
            });
        } catch (error) {
            dispatch({
                type: officeOwnerConstants.DELETE_OFFICE_OWNER_FAILURE,
                payload: { error: error.response?.data?.message || 'Ошибка удаления владельца' },
            });
        }
    };
};